import React from "react";
import { HomeContainer } from "./style";
import CommonSnackbar from "../../../components/common-components/CommonSnackbar";
import CreateNewJobDescription from "./CreateNewJobDescription";
import useCreateNewJD from "./useCreateNewJD";

const CreateJobDescription = () => {
  const {
    newJDDescriptions,
    jdDetails,
    jdLevel,
    level,
    organisationName,
    alertDetail,
    isSubmitting,
    scrollResultRef,
    copyStatus,

    handleSetNewJDDescription,
    handleCreateNewJD,
    setjdLevel,
    handleSetOrganisationName,
    locationInputs,
    locationDropdownOpen,
    setLocationDropdownOpen,
    selectedCountry,
    countryOptions,
    citySearchQuery,
    setCitySearchQuery,
    loadingCities,
    filteredCities,
    handleCountrySelect,
    handleCitySelect,
    handleLocationDropdownClose,
    handleLocationRemove,
    handleLocationClear,
    setAlertDetail,
    handleCopyJD,
    handleExport,
    handleExportDoc,
  } = useCreateNewJD();

  return (
    <HomeContainer>
      <CommonSnackbar
        open={alertDetail.open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        setOpen={setAlertDetail}
        message={alertDetail.message}
        severity={alertDetail.severity}
      />
      <CreateNewJobDescription
        jdDetails={jdDetails}
        newJDDescriptions={newJDDescriptions}
        jdLevel={jdLevel}
        level={level}
        organisationName={organisationName}
        handleSetOrganisationName={handleSetOrganisationName}
        copyStatus={copyStatus}
        scrollResultRef={scrollResultRef}
        isSubmitting={isSubmitting}
        handleCreateNewJD={handleCreateNewJD}
        handleSetNewJDDescription={handleSetNewJDDescription}
        setjdLevel={setjdLevel}
        locationInput={locationInputs}
        locationDropdownOpen={locationDropdownOpen}
        setLocationDropdownOpen={setLocationDropdownOpen}
        selectedCountry={selectedCountry}
        countryOptions={countryOptions}
        citySearchQuery={citySearchQuery}
        setCitySearchQuery={setCitySearchQuery}
        loadingCities={loadingCities}
        filteredCities={filteredCities}
        handleCountrySelect={handleCountrySelect}
        handleCitySelect={handleCitySelect}
        handleLocationDropdownClose={handleLocationDropdownClose}
        handleLocationRemove={handleLocationRemove}
        handleLocationClear={handleLocationClear}
        handleCopyJD={handleCopyJD}
        handleExport={handleExport}
        handleExportDoc={handleExportDoc}
      />
    </HomeContainer>
  );
};

export default CreateJobDescription;
